//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'GlitchImage',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    itemId: {
      type: Number,
      default: 0
    },
    gameStatus: {
      type: String,
      default: null
    },
    isWinner: {
      type: Boolean,
      default: false
    },
    coef: {
      type: Number,
      default: null
    },
    currentRatio: {
      type: Number,
      default: null
    },
    // 可选：禁用全局动画（对应原 SettingsState.disableAnimations）
    disableAnimations: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      paused: false,
      renderedSrc: '',
      baseSrc: ['', ''],
      activeBase: 0,
      swapLock: false,
      
      // 内部状态控制
      timers: [],
      rafIds: [],
      speedScale: 1,
      jitterRunning: false,
      microPaused: false,
      swapVersion: 0,
      destroyed: false
    };
  },
  computed: {
    disabled() {
      return this.disableAnimations;
    },
    shouldGlitch() {
      return (
        !this.disabled &&
        this.gameStatus === "InProgress" &&
        !this.isWinner &&
        !this.paused
      );
    }
  },
  watch: {
    disabled(off) {
      if (off) {
        this.forceStopGlitch();
      } else {
        this.paused = false;
        this.applyStatusSpeed();
      }
    },
    itemId(newVal) {
      if (newVal) {
        this.preloadItemImage(newVal, 'large');
      }
    },
    src: {
      handler(next, prev) {
        if (!next) return;

        if (!prev) {
          this.$set(this.baseSrc, this.activeBase, next);
          this.renderedSrc = next;
        } else if (next !== this.renderedSrc) {
          this.queueSeamlessSwap(next);
        }
      }
    },
    currentRatio(curr, prev) {
      if (this.disabled) return;

      if (this.coef != null && prev != null) {
        const threshold = this.coef;
        if (prev < threshold && curr >= threshold) {
          this.triggerPause();
        }
      }
    },
    coef() {
      if (this.disabled) return;
      this.paused = false;
      this.applyStatusSpeed();
    },
    isWinner(val) {
      if (!this.disabled && val === true) {
        this.applyStatusSpeed();
      }
    },
    gameStatus(val, oldVal) {
      if (!this.disabled && oldVal !== undefined) {
        this.applyStatusSpeed();
      }
    }
  },
  mounted() {
    if (this.src) {
      this.$set(this.baseSrc, this.activeBase, this.src);
      this.renderedSrc = this.src;
    }

    if (!this.disabled) {
      this.applyStatusSpeed();
    }
  },
  beforeDestroy() {
    this.destroyed = true;
    this.clearAllTimers();
    this.swapVersion++;
    this.swapLock = false;
  },
  methods: {
    // 模拟图片预加载服务（可根据你的 Vue 项目调用全局服务/utils）
    preloadItemImage(itemId, size) {
      // ImagePreloaderService.preloadItemImage(itemId, size);
    },

    clearAllTimers() {
      for (const id of this.rafIds) {
        cancelAnimationFrame(id);
      }
      this.rafIds = [];

      for (const id of this.timers) {
        clearInterval(id);
        clearTimeout(id);
      }
      this.timers = [];
      this.jitterRunning = false;
      this.microPaused = false;
    },

    pauseGlitch() {
      this.clearAllTimers();
      this.paused = true;
    },

    triggerPause() {
      this.microPaused = true;
      const t = window.setTimeout(() => {
        this.microPaused = false;
      }, 150);
      this.timers.push(t);
    },

    forceStopGlitch() {
      this.pauseGlitch();
      const root = this.$el;
      if (!root) return;

      root.querySelector('.glitch-container')?.removeAttribute('style');
      this.resetInlineStyles(root);
    },

    rampToSpeed(targetScale) {
      const steps = 5;
      let i = 0;
      const from = this.speedScale;
      const stepMs = 100;

      const ramp = window.setInterval(() => {
        i++;
        this.speedScale = from + ((targetScale - from) * i) / steps;
        this.updateDurations();

        if (i >= steps) {
          clearInterval(ramp);
          this.timers = this.timers.filter((id) => id !== ramp);
        }
      }, stepMs);

      this.timers.push(ramp);
    },

    applyStatusSpeed() {
      if (this.disabled) return;

      const root = this.$el;
      if (!root) return;

      root.querySelector('.glitch-container')?.removeAttribute('style');
      this.resetInlineStyles(root);

      this.clearAllTimers();

      if (this.isWinner || this.gameStatus !== "InProgress") {
        return;
      }

      this.initRandomEffectsOnce();

      const ratio = this.currentRatio ?? 1;
      const baseSpeed = 3.0;
      const speedFactor = 0.5;
      const maxScale = 5.5;
      const calculated = baseSpeed + (ratio - 1) * speedFactor;
      const targetScale = Math.min(calculated, maxScale);

      this.rampToSpeed(targetScale);

      const ensureId = window.setTimeout(() => this.ensureJitterRunning(), 0);
      this.timers.push(ensureId);
    },

    updateDurations() {
      const root = this.$el;
      if (!root) return;

      const setDur = (sel, baseSec) => {
        root.querySelectorAll(sel).forEach((node) => {
          if (node instanceof HTMLElement) {
            node.style.animationDuration = `${(baseSec / this.speedScale).toFixed(3)}s`;
          }
        });
      };

      setDur('.base', 2.5);
      setDur('.red', 1.5);
      setDur('.blue', 1.8);
      setDur('.green', 2.0);
    },

    initRandomEffectsOnce() {
      if (this.jitterRunning && this.timers.length) return;

      this.jitterRunning = true;
      const root = this.$el;
      if (!root) return;

      const sliceFn = () => {
        if (this.swapLock) return;

        const layers = Array.from(root.querySelectorAll('.glitch-layer'));
        layers.forEach((layer) => {
          const top = Math.random() * 80;
          const height = Math.random() * 25 + 10;
          layer.style.clipPath = `inset(${top}% 0 ${100 - top - height}% 0)`;
        });
      };

      const layerJitter = () => {
        if (this.swapLock || this.microPaused) return;

        const layers = Array.from(root.querySelectorAll('.glitch-layer'));
        const power = Math.min(this.currentRatio ?? 1, 5);

        layers.forEach((layer) => {
          const dx = (Math.random() * 8 - 4) * power * 0.2;
          const dy = (Math.random() * 8 - 4) * power * 0.2;
          const hue = (Math.random() * 60 - 30).toFixed(1);

          layer.style.setProperty('--hue-offset', `${hue}deg`);
          layer.style.transform = `translate(${dx}px, ${dy}px)`;
        });
      };

      const baseJitter = () => {
        if (this.swapLock || this.microPaused) return;

        const bases = root.querySelectorAll('.base');
        let baseNode = bases[this.activeBase] || root.querySelector('.base.visible');

        if (!baseNode) return;

        const power = Math.min(this.currentRatio ?? 1, 5);
        const dx = (Math.random() * 30 - 15) * power * 0.2;
        const dy = (Math.random() * 30 - 15) * power * 0.2;

        const inactive = bases[this.activeBase ^ 1];
        if (inactive) {
          inactive.style.transform = '';
        }

        baseNode.style.transform = `translate(${dx}px, ${dy}px)`;
      };

      sliceFn();
      layerJitter();
      baseJitter();

      this.timers.push(
        window.setInterval(sliceFn, 120),
        window.setInterval(layerJitter, 80),
        window.setInterval(baseJitter, 100)
      );
    },

    queueSeamlessSwap(nextUrl) {
      if (!nextUrl) return;

      if (
        nextUrl === this.renderedSrc &&
        nextUrl === this.baseSrc[this.activeBase]
      ) {
        return;
      }

      const ver = ++this.swapVersion;
      const inactive = this.activeBase ^ 1;

      this.swapLock = true;
      this.$set(this.baseSrc, inactive, nextUrl);

      const img = new Image();
      img.decoding = 'async';
      img.src = nextUrl;

      const commit = () => {
        if (ver !== this.swapVersion || this.destroyed) return;

        this.runRAF(() => {
          if (this.destroyed) return;

          this.activeBase = inactive;
          this.renderedSrc = nextUrl;

          const ensureId2 = window.setTimeout(
            () => this.ensureJitterRunning(),
            0
          );
          this.timers.push(ensureId2);

          this.runRAF(() => {
            if (this.destroyed) return;

            const root = this.$el;
            if (root) this.resetInlineStyles(root);

            const unfreeze = window.setTimeout(() => {
              if (ver !== this.swapVersion || this.destroyed) return;

              this.swapLock = false;
              this.clearAllTimers();
              this.applyStatusSpeed();
              this.ensureJitterRunning();
            }, 120);

            this.timers.push(unfreeze);
          });
        });
      };

      if ('decode' in img && typeof img.decode === 'function') {
        img.decode().then(commit, commit);
      } else if (img.complete && img.naturalWidth > 0) {
        commit();
      } else {
        const done = () => {
          cleanup();
          commit();
        };
        const cleanup = () => {
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
        };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    },

    ensureJitterRunning() {
      if (this.destroyed) return;

      if (
        this.disabled ||
        this.isWinner ||
        this.gameStatus !== "InProgress"
      ) {
        return;
      }

      if (!this.jitterRunning || this.timers.length === 0) {
        this.jitterRunning = false;
        this.initRandomEffectsOnce();
      }
    },

    resetInlineStyles(root) {
      root.querySelectorAll('.base, .glitch-layer').forEach((el) => {
        if (el instanceof HTMLElement) {
          el.style.animationDuration = '';
          el.style.transform = '';
          el.style.clipPath = '';
        }
      });
    },

    runRAF(cb) {
      const id = requestAnimationFrame(cb);
      this.rafIds.push(id);
      return id;
    }
  }
};
